const makeRequest = (url, method, body, headers) => {
  return fetch(url, {
    method: method,
    headers: headers,
    body: body,
  });
};

export default makeRequest;
